
console.log("SCRIPT FILE");

// Prevent GSAP errors on pages where the animation markup isn't present.
// This file is loaded globally, so we must guard all DOM queries.
function canRunPourNousAnimation() {
  // Key container(s) used by the timelines and DOM reordering
  const hasWrapper = document.querySelector('.sw--top-wrapper');
  const hasTrigger = document.querySelector('.js-animation') || document.querySelector('.sw--universe-top.desktop');
  const hasWorld = document.querySelector('.sw--pour-nous-world');

  return Boolean(hasWrapper && hasTrigger && hasWorld);
}

// Desktop Function
  function animSecDesktopFunc() {
    console.log("Desktop func");
    if (!canRunPourNousAnimation()) return;
    // Set initial states for all elements
      gsap.set(".sw--pour-nous-world", { scale: 2, transformOrigin: "center center" });
      gsap.set(".sw--pour-nous-item",{ scale: 0.5, transformOrigin: "center center", opacity: 0 });
      gsap.set("#black-dot-anim", { opacity: 0,});
      gsap.set(".sw--pour-nous-y img", { y: window.innerHeight });
      gsap.set([".js-h2-animation", ".sw--pour-nous-universe-img", ".sw--pour-nous-dot"], { opacity: 0 });
      gsap.set([".sw--text-block-8",".sw--text-block-9",".sw--text-block-10",".sw--text-block-11",],{ y: window.innerHeight,});
  
    // Universe animation timeline desktop
    const universeTLDesktop = gsap.timeline({
      scrollTrigger: {
        trigger: ".js-animation",
        start: "top top",
        end: "+=1000%",
        scrub: 1,
        pin: true,
        pinSpacing: true,
        anticipatePin: 1,
        // markers: true
      },
    });
  
    // Universe animations desktop
    universeTLDesktop
      .to(".sw--pour-nous-world", { scale: 1, duration: 0.2, ease: "power1.out",})
      .to(".js-h2-animation", { opacity: 1, duration: 0.8, ease: "power1.out", }, "<=50%")
      .to(".sw--pour-nous-universe-img", {transformOrigin: "center center", opacity: 1, duration: 0.3, ease: "power1.out", }, "-=1")
      .to(".sw--pour-nous-item", { opacity: 1, scale: 1, stagger: 0.2, duration: 0.5, ease: "back.out", }, "-=0.8")
      .to({}, { duration: 0.5 })
      .to(".sw--pour-nous-item", { opacity: 0, scale: 0.5, stagger: 0.2, duration: 0.4, ease: "power1.in", }, "-=0.5")
      .to(".sw--pour-nous-universe-img", { opacity: 0, scale: 0.8, duration: 0.5, ease: "power1.out", }, "-=0.5")
      .to(".js-h2-animation", { opacity: 0, duration: 1, ease: "power1.in", }, "-=1.2")
      .to(".sw--pour-nous-world", { scale: 2, duration: 2, ease: "power2.out",})
      .to(".sw--text-block-8", { y: '-50%', duration: 1.2, ease: "power1.out", onStart: () => {
        const img = document.querySelector(".sw--pour-nous-world img");
        if (img) img.classList.add("animateEarth");
      } }, "<=0%")
      .to(".sw--text-block-9", { y: '-50%', duration: 1.2, ease: "power1.out", }, "<=50%")
      .to(".sw--text-block-8", { y: -window.innerHeight - 100, duration: 1.2, ease: "power1.out", })
      .to(".sw--text-block-10", { y: '-50%', duration: 1.2, ease: "power1.out", }, "<=10%")
      .to(".sw--text-block-9", { y: -window.innerHeight - 100, duration: 1.2, ease: "power1.out", })
      .to(".sw--text-block-11", { y: '-50%', duration: 1.2, ease: "power1.out", }, "<=10%")
      .to({}, { duration: 0.5 })
      // .to([".sw--text-block-10", ".sw--text-block-11"], { y: -window.innerHeight - 100, duration: 1.2, ease: "power1.out", onStart: () => { document.querySelector(".sw--pour-nous-world img").classList.remove("animateEarth") } })
      // .to( ".sw--pour-nous-world", { scale: 0.3, duration: 1.2, ease: "power1.out"}, "<-=20%")
      // .to(".sw--pour-nous-y img", { y: 20, x: -8 }, "<=50%")
      // .to( "#black-dot-anim", { opacity: 1, duration: 1.2, ease: "power1.out"}, "<=50%")
      // .to( ".sw--pour-nous-world", { y: -window.innerHeight / 4, duration: 0.8, ease: "power1.out"}, "<=90%")
      // .to(".sw--pour-nous-y img", { y: window.innerHeight / 4, opacity: 0, duration: 0.5, ease: "power1.out" }, "<=50%")
      // .to( ".sw--pour-nous-world", { y: "+=150", duration: 0.8, ease: "power1.out"})


    // universeTLDesktop
    //   .to(".sw--pour-nous-world", { scale: 1, duration: 0.2, ease: "power1.out",})
    //   .to(".js-h2-animation", { opacity: 1, duration: 0.8, ease: "power1.out", }, "<=50%")
    //   .to(".sw--pour-nous-universe-img", {transformOrigin: "center center", opacity: 1, duration: 0.3, ease: "power1.out", }, "-=1")
    //   .to(".sw--pour-nous-item", { opacity: 1, scale: 1, stagger: 0.2, duration: 0.5, ease: "back.out", }, "-=0.8")
    //   .to({}, { duration: 0.5 })
    //   .to(".sw--pour-nous-item", { opacity: 0, scale: 0.5, stagger: 0.2, duration: 0.4, ease: "power1.in", }, "-=0.5")
    //   .to(".sw--pour-nous-universe-img", { opacity: 0, scale: 0.8, duration: 0.5, ease: "power1.out", }, "-=0.5")
    //   .to(".js-h2-animation", { opacity: 0, duration: 1, ease: "power1.in", }, "-=1.2")
    //   .to(".sw--pour-nous-world", { scale: 2.2, duration: 2, ease: "power2.out",})
    //   .to(".sw--text-block-8", { y: '-50%', duration: 1.2, ease: "power1.out", }, "<=0%")
    //   .to(".sw--text-block-9", { y: '-50%', duration: 1.2, ease: "power1.out", }, "<=50%")
    //   .to(".sw--text-block-8", { y: -window.innerHeight - 100, duration: 1.2, ease: "power1.out", })
    //   .to(".sw--text-block-10", { y: '-50%', duration: 1.2, ease: "power1.out", }, "<=10%")
    //   .to(".sw--text-block-9", { y: -window.innerHeight - 100, duration: 1.2, ease: "power1.out", })
    //   .to(".sw--text-block-11", { y: '-50%', duration: 1.2, ease: "power1.out", }, "<=10%")
    //   .to({}, { duration: 0.5 })
    //   .to([".sw--text-block-10", ".sw--text-block-11"], { y: -window.innerHeight - 100, duration: 1.2, ease: "power1.out", })
    //   .to( ".sw--pour-nous-world", { scale: 0.3, duration: 1.2, ease: "power1.out"}, "<-=20%")
    //   .to(".sw--pour-nous-y img", { y: 0, x: -8 }, "<=50%")
    //   .to( "#black-dot-anim", { opacity: 1, duration: 1.2, ease: "power1.out"}, "<=50%")
    //   .to( ".sw--pour-nous-world", { y: -window.innerHeight / 4, duration: 0.8, ease: "power1.out"}, "<=90%")
    //   .to(".sw--pour-nous-y img", { y: window.innerHeight / 4, opacity: 0, duration: 0.5, ease: "power1.out" }, "<=50%")
    //   .to( ".sw--pour-nous-world", { y: window.innerHeight / 14, duration: 0.8, ease: "power1.out"})
      
  }




// Mobile Function
  function animSecMobileFunc() {
    console.log("Mobile func");
      if (!canRunPourNousAnimation()) return;
      const wrapper = document.querySelector(".sw--top-wrapper");
      const universeTop = wrapper?.querySelector(".sw--universe-top.desktop");
      const pourNousBottom = wrapper?.querySelector(".sw--pour-nous-bottom");
      if (wrapper && universeTop && pourNousBottom) {
        wrapper.insertBefore(universeTop, pourNousBottom);
      }

    
    // Set initial states for all elements
      gsap.set(".sw--pour-nous-world", { scale: 2, transformOrigin: "center center" });
      gsap.set(".sw--pour-nous-item",{ scale: 0.5, transformOrigin: "center center", opacity: 0 });
      gsap.set("#black-dot-anim", { opacity: 0,});
      gsap.set(".sw--pour-nous-y img", { y: window.innerHeight });
      gsap.set([".js-h2-animation",".sw--pour-nous-universe-img",".sw--pour-nous-dot",],{ opacity: 0,});
      gsap.set("#y-letter-mobile", { transform: "translate(calc(-50% - 7px), calc(6% + 100px))", opacity: 0});
      

    // Universe animation timeline Mobile
      const universeTLMobile = gsap.timeline({
        scrollTrigger: {
          trigger: ".sw--universe-top.desktop",
          start: "top top",
          end: "+=500%",
          scrub: 1,
          pin: true,
          pinSpacing: true,
          anticipatePin: 1,
          // markers: true,
        },
      });

    // Universe animations Mobile
      universeTLMobile
        .to(".sw--universe-top .sw--pour-nous-world", { scale: 0.5, duration: 0.5, ease: "power1.out",})
        .to(".sw--universe-top .js-h2-animation", { opacity: 1, duration: 0.5, ease: "power1.out", }, "<=90%")
        .to(".sw--universe-top .sw--pour-nous-universe-img", {transformOrigin: "center center", opacity: 1, duration: 0.5, ease: "power1.out", }, "<=0%")
        .to(".sw--universe-top .sw--pour-nous-item", { opacity: 1, scale: 1, stagger: 0.2, duration: 0.5, ease: "back.out", }, "<=20%")
        .to(".sw--universe-top .sw--pour-nous-item", { opacity: 0, scale: 0.5, stagger: 0.2, duration: 0.5, ease: "power1.in", }, "-=0.5")
        .to(".sw--universe-top .sw--pour-nous-universe-img", { opacity: 0, scale: 0.8, duration: 0.5, ease: "power1.out", }, "-=0.5")
        // .to(".sw--universe-top .js-h2-animation", { opacity: 0, duration: 1, ease: "power1.out", }, "-=1.2")
        // .to(".sw--universe-top .sw--pour-nous-world", { scale: 0.25, duration: 1.2, ease: "power1.out"}, "<=0%")
        
        // .to("#y-letter-mobile", { transform: "translate(calc(-50% - 7px), 16%)", opacity: 1, duration: 1, ease: "power1.out"}, "<=100%")
        // .to("#y-letter-mobile", { opacity: 0, duration: 1, ease: "power1.out" })
        // .to( "#black-dot-anim", { opacity: 1, duration: 1.2, ease: "power1.out"}, "<=0%")
        // .to( ".sw--pour-nous-world", { y: window.innerHeight, duration: 1.2, ease: "power1.out"}, "<=90%")
        // .to( ".sw--pour-nous-world", { y: 0, duration: 1.2, ease: "power1.out"})
  }


// Ready and Media Query
document.addEventListener("DOMContentLoaded", function () {
  // Only proceed if GSAP is present (defensive) and the page contains the animation markup.
  if (!window.gsap || !window.ScrollTrigger) return;
  if (!canRunPourNousAnimation()) return;

  gsap.registerPlugin(ScrollTrigger);
  
  setTimeout(() => {

    let gsapMediaQueries = gsap.matchMedia();

    
    gsapMediaQueries.add("(max-width: 991px)", () => {
      animSecMobileFunc();
    });
  
    gsapMediaQueries.add("(min-width: 992px)", () => {
      animSecDesktopFunc();
    });

  ScrollTrigger.refresh();
    
  }, "1000");
  
});



  







// ORIGINAL CODE BEFORE ASSEM EDITS
// function initAnimation() {
//   // Set initial states for all elements
//   gsap.set(".sw--pour-nous-world", {
//     scale: 2,
//     transformOrigin: "center center",
//     opacity: 0,
//   });

//   gsap.set(
//     [
//       ".js-h2-animation",
//       ".sw--pour-nous-universe-img",
//       ".sw--pour-nous-item",
//       ".js-stepper",
//       ".sw--pour-nous-dot",
//     ],
//     {
//       opacity: 0,
//     }
//   );

//   gsap.set(".sw--pour-nous-dot", { y: 385 });
//   gsap.set(".sw--pour-nous-y", { y: 1000 });

//   // Universe animation timeline
//   const universeTL = gsap.timeline({
//     scrollTrigger: {
//       // yPercent: -100,
//       trigger: ".js-animation",
//       start: "top top",
//       end: "+=1000%",
//       scrub: 1,
//       pin: true
//     },
//   });

//   // Universe animations
//   universeTL
//     .to(".sw--pour-nous-world", { opacity: 1, scale: 1, duration: 2, ease: "power2.out",})
//     .to(".js-h2-animation", { opacity: 1, duration: 1.2, ease: "sine.out", }, "-=1.3")
//     .to(".sw--pour-nous-universe-img", {transformOrigin: "center center", opacity: 1, duration: 1.5, ease: "power1.out", }, "-=1")
//     .to(".sw--pour-nous-item", { opacity: 1, stagger: 0.2, duration: 0.8, ease: "back.out", }, "-=0.8")
//     .to(".sw--pour-nous-item", { opacity: 0, stagger: 0.2, duration: 0.8, ease: "power1.in", }, "-=0.5")
//     .to(".sw--pour-nous-universe-img", { opacity: 0.1, scale: 0.7, duration: 1.8, ease: "sine.inOut", }, "-=0.5")
//     .to(".js-h2-animation", { opacity: 0, duration: 1, ease: "power1.in", }, "-=1.2")

//     // Text Block 8 Animation and Pinning
//     .to(".sw--text-block-8", { opacity: 1, duration: 1.2, ease: "back.out(0.7)", })
//     .to(".sw--text-block-8", { opacity: 0, duration: 1.2, ease: "back.out(0.7)", })
//     .to(".sw--text-block-9", { opacity: 1, duration: 1.2, ease: "back.out(0.7)", })
//     .to(".sw--text-block-9", { opacity: 0, duration: 1.2, ease: "back.out(0.7)", })
//     .to(".sw--text-block-10", { opacity: 1, duration: 1.2, ease: "back.out(0.7)", })
//     .to(".sw--text-block-10", { opacity: 0, duration: 1.2, ease: "back.out(0.7)", })
//     .to(".sw--text-block-11", { opacity: 1, duration: 1.2, ease: "back.out(0.7)", })
//     .to(".sw--text-block-11", { opacity: 0, duration: 1.2, ease: "back.out(0.7)", })
//     .to( ".sw--pour-nous-world", { scale: 0.5, duration: 1.2, ease: "power2.in", })
//     .to(".sw--pour-nous-y", { y: 370, duration: 1.2, ease: "power2.in", })
//     .to(".sw--pour-nous-world", { opacity: 0, duration: 1.2, ease: "power2.in", }, "-=1")
//     .to(".sw--pour-nous-dot", { opacity: 1, duration: 1.2, ease: "power2.in",}, "-=1")
//     .to(".sw--pour-nous-dot", { y: 0, duration: 1.2, ease: "power2.in", })
//     .to(".sw--pour-nous-y", { opacity: 0, duration: 1.2, ease: "power2.in", })
//     .to(".sw--pour-nous-dot", { y: 1000, opacity: 0, duration: 4, ease: "power2.in", });
// }
